// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u32().primaryKey(),
  name: __t.string(),
  description: __t.string(),
  startsAt: __t.u64().name("starts_at"),
  endsAt: __t.u64().name("ends_at"),
  maxTier: __t.u32().name("max_tier"),
  xpPerTier: __t.u64().name("xp_per_tier"),
  premiumPriceCoins: __t.i64().name("premium_price_coins"),
  isActive: __t.bool().name("is_active"),
});
